import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinhinjewadiitpark() {



const cardData =
  {
    keyword: 'Cab Service in Hinjewadi IT Park',
    heading: 'Sanavi Travels: Cab Service in Hinjewadi IT Park',
    headingDescription: 'Sanavi Travels provides highly reliable, professional, and well-managed Cab Service in Hinjewadi IT Park, catering specifically to IT professionals, corporate employees, MNC staff, business executives, and visiting clients working in one of Pune’s largest IT hubs. Hinjewadi IT Park operates round the clock with multiple shifts, tight schedules, and high employee movement, making dependable transportation essential for smooth daily operations. Our cab services in Hinjewadi IT Park are designed to support office commutes, corporate travel, airport transfers, railway station pickups, team outings, client meetings, and corporate events with maximum efficiency and comfort. We offer a wide fleet of AC and Non-AC sedans and SUVs, all maintained to corporate standards, ensuring clean interiors, comfortable seating, and safe travel even during peak traffic hours. Professional and background-verified drivers are trained to handle IT-park routes, shift timings, traffic conditions, and punctual reporting, ensuring employees reach offices and homes safely and on time. Flexible pickup points, route planning, shift-based scheduling, and transparent pricing make our cab service ideal for both daily office commute and occasional corporate travel. Whether it is employee transportation, management travel, airport coordination, or team outings, Sanavi Travels ensures stress-free, safe, and cost-effective cab services in Hinjewadi IT Park, supporting productivity, employee satisfaction, and seamless corporate mobility.',

    top: 'Cab Travel Solutions in Hinjewadi IT Park',


"topPlaces": [
  {
    "title": "Daily Office Commute",
    "description": "Cab service in Hinjewadi IT Park is extensively used for daily office commute by IT employees working across multiple shifts. Reliable cab transportation ensures punctual arrivals, reduced travel stress, and safe return journeys, especially during late-night or early-morning shifts. Organized cab services play a crucial role in maintaining productivity and work-life balance for IT professionals."
  },
  {
    "title": "Corporate Office Buildings",
    "description": "Hinjewadi IT Park houses numerous multinational companies and corporate offices. Cab services ensure seamless movement of employees, management, and visiting professionals between offices, hotels, and meeting locations. Professional transport reflects corporate discipline and operational efficiency."
  },
  {
    "title": "Airport Transfers for IT Professionals",
    "description": "Frequent air travel is common for IT executives and consultants. Dedicated cab services provide timely airport pickups and drops from Hinjewadi IT Park, ensuring stress-free transfers with ample luggage space and comfortable seating for business travelers."
  },
  {
    "title": "Railway Station Pickups and Drops",
    "description": "Employees and visiting clients often arrive via railway stations. Cab services in Hinjewadi IT Park ensure reliable railway pickups and drops, eliminating confusion, delays, and dependence on public transport."
  },
  {
    "title": "Client and Business Meetings",
    "description": "Corporate meetings require punctual and professional transportation. Cab services support smooth travel for executives and clients attending meetings, presentations, and negotiations across Pune."
  },
  {
    "title": "Corporate Events and Conferences",
    "description": "IT companies frequently organize conferences, seminars, and corporate events. Dedicated cab services manage guest transportation efficiently, ensuring coordinated arrivals and departures."
  },
  {
    "title": "Team Outings and Office Picnics",
    "description": "Cab services play an important role in transporting teams for outings, picnics, and team-building activities. Organized travel ensures safety, coordination, and convenience for all participants."
  },
  {
    "title": "Shift-Based Employee Transport",
    "description": "Hinjewadi operates in multiple shifts, including night shifts. Cab services provide safe and dependable transport for employees working non-standard hours, with trained drivers and monitored routes."
  },
  {
    "title": "Hotel and Guest House Transfers",
    "description": "Visiting professionals often stay in nearby hotels or guest houses. Cab services ensure smooth connectivity between accommodations and IT Park offices."
  },
  {
    "title": "Flexible Corporate Travel Routes",
    "description": "Corporate travel often requires flexible routes and multiple pickup points. Dedicated cab services efficiently manage customized travel plans for IT companies."
  }
]
,



"services": [
{
"name": "Cab Service in Hinjewadi IT Park",
"description": "Cab Service in Hinjewadi IT Park by Sanavi Travels offers a complete transportation solution for IT employees, corporate executives, and business visitors. Designed to support daily office commutes, shift-based travel, corporate meetings, and business movements, this service ensures punctual pickups, safe journeys, and comfortable rides. With professionally trained drivers, well-maintained vehicles, route familiarity, and flexible scheduling, it reduces employee stress, improves punctuality, and supports seamless corporate operations. Transparent pricing, dedicated coordination, and consistent service quality make it ideal for both long-term corporate contracts and occasional travel needs."
},
{
"name": "AC Cab Hire Hinjewadi IT Park",
"description": "AC Cab Hire Hinjewadi IT Park ensures a cool, comfortable, and relaxed travel experience for employees and executives. Fully air-conditioned vehicles with clean interiors, comfortable seating, and smooth suspension make daily commutes and long corporate journeys pleasant, even during peak traffic hours and summer seasons."
},
{
"name": "Non AC Cab Hinjewadi IT Park",
"description": "Non AC Cab Hinjewadi IT Park provides an economical yet reliable travel option for corporate staff and employees. Ideal for budget-focused travel requirements, it maintains safety, punctuality, and professional driver support without compromising essential comfort."
},
{
"name": "Sedan Cab Service Hinjewadi IT Park",
"description": "Sedan Cab Service Hinjewadi IT Park is suitable for individual employees, executives, and small teams. Sedans offer efficient fuel usage, easy maneuverability in traffic, comfortable seating, and professional appearance for corporate travel."
},
{
"name": "SUV Cab Service Hinjewadi IT Park",
"description": "SUV Cab Service Hinjewadi IT Park supports group travel, management transport, and luggage-heavy journeys. Spacious interiors, enhanced comfort, and stable ride quality make SUVs ideal for long routes and senior staff movement."
},
{
"name": "Cab for Office Commute Hinjewadi IT Park",
"description": "Cab for Office Commute Hinjewadi IT Park ensures employees reach offices safely and on time. Scheduled pickups, route optimization, and trained drivers help companies maintain attendance discipline and employee satisfaction."
},
{
"name": "Cab for Corporate Travel Hinjewadi IT Park",
"description": "Cab for Corporate Travel Hinjewadi IT Park supports meetings, conferences, client visits, and inter-office movement. Reliable service and professional conduct reflect positively on corporate image and operational efficiency."
},
{
"name": "Affordable Cab Service Hinjewadi IT Park",
"description": "Affordable Cab Service Hinjewadi IT Park offers cost-effective travel solutions without compromising service quality. Transparent billing, flexible packages, and optimized routes help companies control transportation expenses."
},
{
"name": "Best Cab Service Hinjewadi IT Park",
"description": "Best Cab Service Hinjewadi IT Park by Sanavi Travels is trusted for consistency, safety, punctuality, and professional coordination, making it a preferred choice among IT companies."
},
{
"name": "Cab with Driver Hinjewadi IT Park",
"description": "Cab with Driver Hinjewadi IT Park includes experienced, verified chauffeurs trained in corporate etiquette, safe driving practices, and route knowledge, ensuring smooth and stress-free travel."
},
{
"name": "Cab for Airport Transfer Hinjewadi IT Park",
"description": "Cab for Airport Transfer Hinjewadi IT Park ensures timely pickups and drops for business travelers, supporting flight schedules with comfort, punctuality, and luggage convenience."
},
{
"name": "Cab for Railway Pickup Hinjewadi IT Park",
"description": "Cab for Railway Pickup Hinjewadi IT Park provides reliable station transfers, reducing travel delays and ensuring smooth connectivity for employees and visiting professionals."
},
{
"name": "Cab for IT Employees Hinjewadi IT Park",
"description": "Cab for IT Employees Hinjewadi IT Park focuses on daily commute safety, shift-based scheduling, and dependable transport, supporting workforce productivity and retention."
},
{
"name": "Cab for Corporate Events Hinjewadi IT Park",
"description": "Cab for Corporate Events Hinjewadi IT Park manages transportation for seminars, conferences, and official gatherings, ensuring coordinated and professional travel arrangements."
},
{
"name": "Cab for Team Outing Hinjewadi IT Park",
"description": "Cab for Team Outing Hinjewadi IT Park supports employee engagement activities, picnics, and team-building events with organized, safe, and comfortable travel."
}
],
"tableData": [
["Cab Service Hinjewadi IT Park", "Office Commute Cabs"],
["AC Corporate Cabs", "Non AC Corporate Cabs"],
["Sedan Corporate Cabs", "SUV Corporate Cabs"],
["Airport Transfer Cabs", "Railway Pickup Cabs"],
["Employee Transport", "Corporate Event Cabs"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Specialized IT Park Cab Services",
    "WhyChoosedescription": "Sanavi Travels understands IT Park transport needs and delivers customized cab solutions."
  },
  {
    "WhyChooseheading": "Safe and Reliable Transport",
    "WhyChoosedescription": "Verified drivers and maintained vehicles ensure employee safety and peace of mind."
  },
  {
    "WhyChooseheading": "Punctual and Professional Service",
    "WhyChoosedescription": "On-time pickups and disciplined operations support corporate schedules."
  },
  {
    "WhyChooseheading": "Flexible Shift-Based Scheduling",
    "WhyChoosedescription": "Supports day, night, and rotational shifts for IT professionals."
  },
  {
    "WhyChooseheading": "Cost-Effective Corporate Packages",
    "WhyChoosedescription": "Transparent pricing helps companies manage transport budgets efficiently."
  },
  {
    "WhyChooseheading": "Comfortable Vehicle Fleet",
    "WhyChoosedescription": "AC and Non-AC options ensure comfortable daily travel."
  },
  {
    "WhyChooseheading": "Dedicated Corporate Support",
    "WhyChoosedescription": "Responsive coordination ensures smooth travel operations."
  },
  {
    "WhyChooseheading": "Trusted Corporate Mobility Partner",
    "WhyChoosedescription": "Sanavi Travels is trusted by IT companies for dependable cab services."
  }
]

}

const faqData = [
  {
    question: 'Do you provide cab service in Hinjewadi IT Park?',
    answer: 'Yes, Sanavi Travels offers dedicated cab services for IT professionals and corporate clients in Hinjewadi IT Park.'
  },
  {
    question: 'Are AC and Non AC cabs available?',
    answer: 'Yes, both AC and Non AC cab options are available based on requirement.'
  },
  {
    question: 'Can you support night-shift employee transport?',
    answer: 'Yes, we provide safe and reliable shift-based cab services including night shifts.'
  },
  {
    question: 'Do you offer airport and railway transfers?',
    answer: 'Yes, airport and railway station transfers are available.'
  },
  {
    question: 'Is driver included in the cab service?',
    answer: 'Yes, all cab services include a trained and verified driver.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Kulkarni',
    feedback: 'Very reliable cab service for our IT office commute in Hinjewadi. Highly professional.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Sharma',
    feedback: 'Excellent airport and daily commute cab service. Safe and punctual.',
    rating: 5
  }
];































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Hinjewadi IT Park - Sanavi Travels",
  "description": "Sanavi Travels offers cab services in Hinjewadi IT Park for office commute, corporate travel, IT employee transport, airport and railway pickups, team outings, and corporate events. AC and Non-AC sedans and SUVs are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};





  return (
    <div>


<Helmet>
  <title>
    Call : +91 7387507373 | Cab Service in Hinjewadi IT Park | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book cab service in Hinjewadi IT Park with Sanavi Travels. AC & Non-AC sedans and SUVs for office commute, corporate travel, IT employees, airport, railway, team outings, and corporate events with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/260.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinhinjewadiitpark;